import React from "react";
import { createUseStyles } from "react-jss";
import { useNavigate } from "react-router-dom";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

const useStyles = createUseStyles(() => ({
  firstNavBlock: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
  },
  logo: {
    maxHeight: "38.11px",
    maxWidth: "156.79px",
    minWidth: "55px",
    minHeight: "12px",
    cursor: "pointer",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      verticalAlign: "top",
    },
  },
  burgerBtn: {
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    gap: "4px",
    border: `1px solid #145839`,
    "& span": {
      width: "15px",
      height: "2px",
      background: "#145839",
      display: "block",
    },
  },
  burgerBtnMob: {
    width: "110px",
    height: "35px",
    borderRadius: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    gap: "4px",
    border: `1px solid #145839`,
    "& span": {
      width: "15px",
      height: "2px",
      background: "#145839",
      display: "block",
    },
  },
}));

interface HeaderLeftBlockProps {
  onOpen: () => void;
  logo_url: string;
}

const HeaderLeftBlock: React.FC<HeaderLeftBlockProps> = ({
  onOpen,
  logo_url,
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const onClickHandler = () => navigate("/");

  return (
    <div className={classes.firstNavBlock}>
      <div
        onClick={onOpen}
        className={screens.xs ? classes.burgerBtnMob : classes.burgerBtn}
      >
        <span />
        <span />
        <span />
      </div>
      {/* Логотип */}
      <div className={classes.logo} onClick={onClickHandler}>
        <img src={logo_url} alt="Bellissimo Logo" />
      </div>
    </div>
  );
};

export default HeaderLeftBlock;
